import { IonContent, IonPage } from "@ionic/react";
import Header from "src/components/Header";
import ListaPuntosServicio from "../components/ListaPuntosServicio";

// Pantalla principal del modulo "Asignaciones (nuevo)": lista de puntos de
// servicio. Replica el primer nivel de navegacion de EMSYS.
const AsignacionesV2: React.FC = () => {
  return (
    <IonPage>
      <Header titulo="Asignaciones (nuevo)" />
      <IonContent id="asignaciones-v2">
        <div className="container">
          <div className="d-flex mt-3 flex-column align-items-center">
            <ListaPuntosServicio />
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default AsignacionesV2;
